import {
  baseAPIRequest,
  authAPIRequest,
  fileAPIRequest,
  httpRequestMethods
} from '@/cllib/axios_init'
import * as url from './url'

import store from '@/store'

let dcopy = require('deep-copy')

export const parmAddP = function (parm) {
  let newParm = dcopy(parm)
  if (store.getters.currentPrevilege) {
    newParm[store.getters.currentPrevilege.paramName] = store.getters.currentPrevilege.id
  }
  return newParm
}

export const parmAddData = function (parm, types) {
  let newParm = dcopy(parm)
  if (newParm.groupIds === '') {
    newParm.groupIds = null
  }
  if (newParm.carGroupIds === '') {
    newParm.carGroupIds = null
  }
  if (newParm.companyIds === '') {
    newParm.companyIds = null
  }
  let isDdy = false
  let roles = store.getters.availableRoles || []
  roles.forEach((item) => {
    if (item.name === '调度员') {
      isDdy = true
    }
  })
  if (types.includes('carTeams') && !newParm.carGroupIds && !isDdy) {
    if (store.getters.availableCarteams && store.getters.availableCarteams.length > 0) {
      let carGroupIds = []
      store.getters.availableCarteams.forEach((item) => {
        carGroupIds.push(item.id)
      })
      newParm.carGroupIds = carGroupIds.join(',')
    }
  }
  if (types.includes('groupIds') && !newParm.groupIds) {
    if (store.getters.availableGroups && store.getters.availableGroups.length > 0) {
      let groupIds = []
      store.getters.availableGroups.forEach((item) => {
        groupIds.push(item.id)
      })
      newParm.groupIds = groupIds.join(',')
    }
  }
  if (types.includes('companyIds') && !newParm.companyIds) {
    if (store.getters.availableCompanys && store.getters.availableCompanys.length > 0) {
      let companyIds = []
      store.getters.availableCompanys.forEach((item) => {
        companyIds.push(item.id)
      })
      newParm.companyIds = companyIds.join(',')
    }
  }
  if (newParm.companyIds) {
    newParm.gasCompanyIds = newParm.companyIds
    newParm.companyIds = null
  }
  if (newParm.groupId) {
    newParm.groupIds = null
  }
  return newParm
}

export function login (parm) {
  return baseAPIRequest(url.login.login, httpRequestMethods.POST, parm)
}

export function userGetSalt (parm) {
  return baseAPIRequest(url.user.getSalt, httpRequestMethods.GET, parm)
}

export function userGetVImg (parm) {
  return baseAPIRequest(url.user.getVImg, httpRequestMethods.GET, parm, true)
}

export function wxauth (parm) {
  return baseAPIRequest(url.login.wxauth, httpRequestMethods.POST, parm)
}

export function getTokenByCode (code) {
  return baseAPIRequest(url.login.getTokenByCode(code), httpRequestMethods.GET)
}

// users
export function usersUpdate (parm) {
  return authAPIRequest(url.users.update(parm.id), httpRequestMethods.PUT, parm)
}

export function mapGetData () {
  return []
}

export function mapGetDataNew () {
  return []
}

// 无引用的废弃函数
export function mapGetData2 () {
  return []
}

export function mapGetGasData () {
  return []
}

export function mapGetSaleByName () {
  return []
}

export function mapGetDepot () {
  return []
}

export function mapGetDepotByStatus () {
  return []
}

export function getUserMenu () {
  return authAPIRequest(url.user.getMenu, httpRequestMethods.GET)
}

export function getUserInfo () {
  return authAPIRequest(url.user.getInfo, httpRequestMethods.GET)
}

export function userLogOut () {
  return authAPIRequest(url.user.logOut, httpRequestMethods.DELETE)
}

export function userGetUserDriver () {
  return authAPIRequest(url.user.getUserDriver, httpRequestMethods.GET)
}

// planProgress
export function planProgressGetData (parm) {
  return authAPIRequest(url.planProgress.basUrl, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'companyIds', 'carTeams']))
}
// holiday
export function holidayGet (parm) {
  return authAPIRequest(url.holiday.getUrl, httpRequestMethods.GET, parm)
}

export function holidayAdd (parm) {
  return authAPIRequest(url.holiday.basUrl, httpRequestMethods.POST, parm)
}

export function holidayUpdate (id, parm) {
  return authAPIRequest(url.holiday.parmUrl(id), httpRequestMethods.PUT, parm)
}

export function holidayDel (id) {
  return authAPIRequest(url.holiday.delUrl(id), httpRequestMethods.DELETE)
}

// ajustRouterOrder
export function ajustRouterOrderGet (parm) {
  return authAPIRequest(url.ajustRouterOrder.basUrl, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'companyIds', 'carTeams']))
}

export function ajustRouterOrderAdd (parm) {
  return authAPIRequest(url.ajustRouterOrder.basUrl, httpRequestMethods.POST, parm)
}

export function ajustRouterOrderUpdate (id, parm) {
  return authAPIRequest(url.ajustRouterOrder.parmUrl(id), httpRequestMethods.PUT, parm)
}

export function ajustRouterOrderDel (id, str) {
  return authAPIRequest(url.ajustRouterOrder.delUrl(id, str), httpRequestMethods.DELETE)
}

// stockReceipt
export function stockReceiptGetData (parm) {
  return authAPIRequest(url.stockReceipt.basUrl, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'companyIds', 'carTeams']))
}

export function stockReceiptAddData (parm) {
  return authAPIRequest(url.stockReceipt.basUrl, httpRequestMethods.POST, parm)
}

export function stockReceiptDelData (id) {
  return authAPIRequest(url.stockReceipt.parmUrl(id), httpRequestMethods.DELETE)
}

// gasRequireOrder
export function gasRequireOrderGet (parm) {
  return authAPIRequest(url.gasRequireOrder.basUrl, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'companyIds', 'carTeams']))
}

export function gasRequireOrderAdd (parm) {
  return authAPIRequest(url.gasRequireOrder.basUrl, httpRequestMethods.POST, parm)
}

export function gasRequireOrderDel (id) {
  return authAPIRequest(url.gasRequireOrder.parmUrl(id), httpRequestMethods.DELETE)
}

export function gasRequireOrderUpdate (id, parm) {
  return authAPIRequest(url.gasRequireOrder.parmUrl(id), httpRequestMethods.PUT, parm)
}

// countData
export function countDataGasInventory (parm) {
  return authAPIRequest(url.countData.gasInventory, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'companyIds', 'carTeams']))
}

export function countDataSignCar (parm) {
  return authAPIRequest(url.countData.signCar, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'carTeams']))
}

export function countDataDistributionFreights (parm) {
  return authAPIRequest(url.countData.distributionFreights, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'carTeams', 'companyIds']))
}

export function countDataDistributionWeights (parm) {
  return authAPIRequest(url.countData.distributionWeights, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'carTeams', 'companyIds']))
}

export function countDataDaily (parm) {
  return authAPIRequest(url.countData.daily, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'carTeams', 'companyIds']))
}

export function countDataCarData (parm) {
  return authAPIRequest(url.countData.carData, httpRequestMethods.GET, parm)
}

export function countDataDistributionEfficiency () {
  return authAPIRequest(url.countData.distributionEfficiency, httpRequestMethods.GET)
}

// gasDispatchStatus
export function gasDispatchStatusGetGasOilData (parm) {
  return authAPIRequest(url.gasDispatchStatus.getGasOilData, httpRequestMethods.GET, parm)
}

export function gasDispatchStatusGetOrder (parm) {
  return authAPIRequest(url.gasDispatchStatus.getOrderData, httpRequestMethods.GET, parm)
}

// platformWarn
export function platformWarnGet (parm) {
  return authAPIRequest(url.platformWarn.basUrl, httpRequestMethods.GET, parm)
}

// gasSale
export function gasSaleGetSale (parm) {
  return authAPIRequest(url.gasSale.getSale, httpRequestMethods.GET, parm)
}

export function gasSaleUpdatePreSale (parm) {
  return authAPIRequest(url.gasSale.updatePreSale(parm.id), httpRequestMethods.PUT, parm)
}

// group
export function groupGetData () {
  return authAPIRequest(url.group.basUrl, httpRequestMethods.GET)
}

export function groupGetCarteams (parm) {
  return authAPIRequest(url.group.getGroupCarTeams, httpRequestMethods.GET, parm)
}

export function groupUpdateCarteam (id, parm) {
  return authAPIRequest(url.group.carTeam(id), httpRequestMethods.PUT, parm)
}

export function groupUpdateData (id, parm) {
  return authAPIRequest(url.group.groupParmUrl(id), httpRequestMethods.PUT, parm)
}

export function groupDelData (id) {
  return authAPIRequest(url.group.groupParmUrl(id), httpRequestMethods.DELETE)
}

export function groupAddData (parm) {
  return authAPIRequest(url.group.groupUrl, httpRequestMethods.POST, parm)
}

export function gasGroupOutGet (parm) {
  return authAPIRequest(url.gasGroupOut.basUrl, httpRequestMethods.GET, parm)
}

export function gasGroupOutUpdate (parm) {
  return authAPIRequest(url.gasGroupOut.update, httpRequestMethods.POST, parm)
}

export function gasGroupOutDel (parm) {
  return authAPIRequest(url.gasGroupOut.del(parm.id), httpRequestMethods.DELETE, parm)
}

export function gatePassGet (parm) {
  return authAPIRequest(url.gatePass.type, httpRequestMethods.GET, parm)
}

// gasPromotion
export function gasPromotionInputData (file, date) {
  let parm = new window.FormData()
  parm.append('file', file, file.name)
  parm.append('date', date)
  return fileAPIRequest(url.gasPromotion.inputUrl, httpRequestMethods.POST, parm, true)
}

export function gasPromotionGetData (parm) {
  return authAPIRequest(url.gasPromotion.basUrl, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'companyIds', 'carTeams']))
}

export function gasPromotionUpdateData (parm) {
  return authAPIRequest(url.gasPromotion.basUrl, httpRequestMethods.POST, parm)
}

export function gasPromotionDelData (parm) {
  return authAPIRequest(url.gasPromotion.delData, httpRequestMethods.POST, parm)
}

export function gasPromotionOutputTemplate () {
  return authAPIRequest(url.gasPromotion.outputTemplate, httpRequestMethods.GET, {}, true)
}

// common 公用
export function outputData (parm) {
  return authAPIRequest(url.common.outputData, httpRequestMethods.GET, parm, true)
}

// dispatchHomeCount 调运首页
export function dispatchHomeCountGetData () {
  return authAPIRequest(url.dispatchHomeCount.basUrl, httpRequestMethods.GET)
}

export function dispatchHomeCountYearFreight () {
  return authAPIRequest(url.dispatchHomeCount.yearFreight, httpRequestMethods.GET)
}

export function dispatchHomeCountLossRatio () {
  return authAPIRequest(url.dispatchHomeCount.lossRatio, httpRequestMethods.GET)
}

// homeTj
export function homeTjCollectData () {
  return authAPIRequest(url.homeTj.collectData, httpRequestMethods.GET)
}

export function homeTjIsPre () {
  return authAPIRequest(url.homeTj.isPre, httpRequestMethods.GET)
}

export function homeTjDiff () {
  return authAPIRequest(url.homeTj.diff, httpRequestMethods.GET)
}

export function homeTjIsOrder () {
  return authAPIRequest(url.homeTj.isOrder, httpRequestMethods.GET)
}

export function homeTjRouteOrder (parm) {
  return authAPIRequest(url.homeTj.routeOrder, httpRequestMethods.GET, parm)
}

export function homeTjPre (parm) {
  return authAPIRequest(url.homeTj.pre, httpRequestMethods.GET, parm)
}

export function homeTjPrice () {
  return authAPIRequest(url.homeTj.price, httpRequestMethods.GET)
}

export function homeTjWarn () {
  return authAPIRequest(url.homeTj.warn, httpRequestMethods.GET)
}

export function homeTjPreRatio (parm) {
  return authAPIRequest(url.homeTj.preRatio, httpRequestMethods.GET, parm)
}

export function homeTjOptimalGas (parm) {
  return authAPIRequest(url.homeTj.optimalGas, httpRequestMethods.GET, parm)
}

export function homeTjOptimalDistribution () {
  return authAPIRequest(url.homeTj.optimalDistribution, httpRequestMethods.GET)
}

// assess
export function assessGasDaily (parm) {
  return authAPIRequest(url.assess.gasDaily, httpRequestMethods.GET, parm)
}

export function assessGasDailyDetail (parm) {
  return authAPIRequest(url.assess.gasDailyDetail, httpRequestMethods.GET, parm)
}

export function assessDistribution (parm) {
  return authAPIRequest(url.assess.distribution, httpRequestMethods.GET, parm)
}

export function assessDistributionDetail (parm) {
  return authAPIRequest(url.assess.distributionDetail, httpRequestMethods.GET, parm)
}

export function assessCarSign (parm) {
  return authAPIRequest(url.assess.carSign, httpRequestMethods.GET, parm)
}

export function assessCarSignDetail (parm) {
  return authAPIRequest(url.assess.carSignDetail, httpRequestMethods.GET, parm)
}

export function assessSignDetail (parm) {
  return authAPIRequest(url.assess.signDetail, httpRequestMethods.GET, parm)
}

// dictionary

export function dictionaryGet (parm) {
  return authAPIRequest(url.dictionary.basUrl, httpRequestMethods.GET, parm)
}

export function dictionaryUpdate (id, parm) {
  return authAPIRequest(url.dictionary.parmUrl(id), httpRequestMethods.PUT, parm)
}

// dictionary2

export function dictionary2Get (parm) {
  return authAPIRequest(url.dictionary2.basUrl, httpRequestMethods.GET, parm)
}

export function dictionary2Update (id, parm) {
  return authAPIRequest(url.dictionary2.parmUrl(id), httpRequestMethods.PUT, parm)
}

// serverStatus
export function serverStatusGetData () {
  return authAPIRequest(url.serverStatus.basUrl, httpRequestMethods.GET)
}

export function serverStatusGetPsdData () {
  return authAPIRequest(url.serverStatus.getPsdStatus, httpRequestMethods.GET)
}

export function serverStatusUpdateStatus (id, flag) {
  return authAPIRequest(url.serverStatus.updateStatus(id, flag), httpRequestMethods.PUT)
}

export function serverStatusGetYwyStatus () {
  return authAPIRequest(url.serverStatus.getYwyStatus, httpRequestMethods.GET)
}

// interfaceStatus
export function interfaceStatusGetData (flag) {
  return authAPIRequest(url.interfaceStatus.basUrl(flag), httpRequestMethods.GET)
}

// role
export function roleGetData () {
  return authAPIRequest(url.role.basUrl, httpRequestMethods.GET)
}

export function roleAddData (parm) {
  return authAPIRequest(url.role.basUrl, httpRequestMethods.POST, parm)
}

export function roleUpdateData (parm) {
  return authAPIRequest(url.role.parmUrl(parm.roleId), httpRequestMethods.PUT, parm)
}

export function roleDelData (parm) {
  return authAPIRequest(url.role.parmUrl(parm.roleId), httpRequestMethods.DELETE)
}

// carAgent
export function carAgentAddData (parm) {
  return authAPIRequest(url.carAgent.basUrl, httpRequestMethods.POST, parm)
}

export function carAgentUpdateData (id, parm) {
  return authAPIRequest(url.carAgent.parmUrl(id), httpRequestMethods.PUT, parm)
}

export function carAgentDelData (id) {
  return authAPIRequest(url.carAgent.parmUrl(id), httpRequestMethods.DELETE)
}

// distributionAssess
export function distributionAssessGetData (parm) {
  return authAPIRequest(url.distributionAssess.getList, httpRequestMethods.GET, parm)
}

export function distributionAssessAddData (parm) {
  return authAPIRequest(url.distributionAssess.basUrl, httpRequestMethods.POST, parm)
}

// carAgentGasGroup
export function carAgentGasGroupAddData (parm) {
  return authAPIRequest(url.carAgentGasGroup.basUrl, httpRequestMethods.POST, parm)
}

export function carAgentGasGroupUpdateData (id, parm) {
  return authAPIRequest(url.carAgentGasGroup.parmUrl(id), httpRequestMethods.PUT, parm)
}

export function carAgentGasGroupDelData (id) {
  return authAPIRequest(url.carAgentGasGroup.parmUrl(id), httpRequestMethods.DELETE)
}

// depotdiff
export function depotdiffGetData (parm) {
  return authAPIRequest(url.depotdiff.basUrl, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'companyIds', 'carTeams']))
}

export function depotdiffGetCrossReasons () {
  return authAPIRequest(url.depotdiff.getCrossReasons, httpRequestMethods.GET)
}

export function depotdiffUpdateCrossReason (parm) {
  return authAPIRequest(url.depotdiff.updateCrossReason, httpRequestMethods.POST, parm)
}

export function depotdiffOutput (parm) {
  return authAPIRequest(url.depotdiff.outPut, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'companyIds', 'carTeams']), true)
}

// company
export function companyGetData () {
  return authAPIRequest(url.company.basUrl, httpRequestMethods.GET, {noPage: 1})
}

// emptyTank
export function emptyTankGetData (parm) {
  return authAPIRequest(url.emptyTank.basUrl, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'companyIds']))
}

export function emptyTankGetRouterOrder (parm) {
  return authAPIRequest(url.routerOrder.basUrl, httpRequestMethods.GET, parm)
}

export function emptyTankGetDistribution (parm) {
  return authAPIRequest(url.distribution.basUrl, httpRequestMethods.GET, parm)
}

// defaultDepot
export function defaultDepotGetData (parm) {
  return authAPIRequest(url.defaultDepot.basUrl, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'companyIds']))
}

export function defaultDepotAddData (parm) {
  return authAPIRequest(url.defaultDepot.basUrl, httpRequestMethods.POST, parm)
}

export function defaultDepotUpdateData (parm) {
  return authAPIRequest(url.defaultDepot.parmUrl(parm.id), httpRequestMethods.PUT, parm)
}

export function defaultDepotDelData (id) {
  return authAPIRequest(url.defaultDepot.parmUrl(id), httpRequestMethods.DELETE)
}

export function defaultDepotGetWarningData (parm) {
  return authAPIRequest(url.defaultDepot.warning, httpRequestMethods.GET, parmAddData(parm, ['groupIds']))
}

export function defaultDepotOutputTemplate () {
  return authAPIRequest(url.defaultDepot.outputTemplate, httpRequestMethods.GET, {}, true)
}

// depotLoadTime
export function depotLoadTimeGetChartData (parm) {
  return authAPIRequest(url.depotLoadTime.basUrl, httpRequestMethods.GET, parm)
}

export function depotLoadTimeGetDistribution (parm) {
  return authAPIRequest(url.depotLoadTime.getDistribution, httpRequestMethods.GET, parm)
}

export function depotLoadTimeGetDeoptList () {
  return authAPIRequest(url.depotLoadTime.getDeoptList, httpRequestMethods.GET, {noPage: 1})
}

// gasTankStrand
export function gasTankStrandGet (parm) {
  return authAPIRequest(url.gasTankStrand.basUrl, httpRequestMethods.GET, parmAddData(parm, ['companyIds', 'groupIds', 'carTeams']))
}

export function gasTankStrandAdd (parm) {
  return authAPIRequest(url.gasTankStrand.basUrl, httpRequestMethods.POST, parm)
}

export function gasTankStrandUpdate (id, parm) {
  return authAPIRequest(url.gasTankStrand.parmUrl(id), httpRequestMethods.PUT, parm)
}

export function gasTankStrandDel (id) {
  return authAPIRequest(url.gasTankStrand.parmUrl(id), httpRequestMethods.DELETE)
}

// gasStrand
export function gasStrandGetData (parm) {
  return authAPIRequest(url.gasStrand.basUrl, httpRequestMethods.GET, parmAddData(parm, ['companyIds', 'groupIds', 'carTeams']))
}

export function gasStrandAddData (parm) {
  return authAPIRequest(url.gasStrand.basUrl, httpRequestMethods.POST, parm)
}

export function gasStrandUpdateData (id, parm) {
  return authAPIRequest(url.gasStrand.parmUrl(id), httpRequestMethods.PUT, parm)
}

export function gasStrandDelData (id) {
  return authAPIRequest(url.gasStrand.parmUrl(id), httpRequestMethods.DELETE)
}

export function gasStrandOutputTemplate () {
  return authAPIRequest(url.gasStrand.outputTemplate, httpRequestMethods.GET, {}, true)
}

export function gasStrandInputUpdate (data) {
  return authAPIRequest(url.gasStrand.inputUrl, httpRequestMethods.POST, data)
}

// distance
export function distanceGetData (parm) {
  return authAPIRequest(url.distance.basUrl, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'companyIds']))
}

export function distanceAddData (parm) {
  return authAPIRequest(url.distance.basUrl, httpRequestMethods.POST, parm)
}

export function distanceUpdateData (parm) {
  return authAPIRequest(url.distance.parmUrl(parm.id), httpRequestMethods.PUT, parm)
}

export function distanceDelData (id) {
  return authAPIRequest(url.distance.parmUrl(id), httpRequestMethods.DELETE)
}

export function distanceGetWarningData (parm) {
  return authAPIRequest(url.distance.warning, httpRequestMethods.GET, parmAddData(parm, ['groupIds']))
}

export function distanceOutputTemplate () {
  return authAPIRequest(url.distance.outputTemplate, httpRequestMethods.GET, {}, true)
}

export function distanceInputUpdate (data) {
  return authAPIRequest(url.distance.inputUrl, httpRequestMethods.POST, data)
}

//  depotDistance

export function depotDistanceGetData (parm) {
  return authAPIRequest(url.depotDistance.basUrl, httpRequestMethods.GET, parm)
}

// gas
export function gasGetGasList (parm) {
  return authAPIRequest(url.gas.basUrl, httpRequestMethods.GET, parmAddData(parm, ['companyIds', 'groupIds']))
}

export function gasGetGasWarningList () {
  return authAPIRequest(url.gas.warningData, httpRequestMethods.GET)
}

export function gasAddGas (parm) {
  return authAPIRequest(url.gas.basUrl, httpRequestMethods.POST, parm)
}

export function gasUpdateGas (parm) {
  return authAPIRequest(url.gas.parmUrl(parm.id), httpRequestMethods.PUT, parm)
}

export function gasDeleteGas (id) {
  return authAPIRequest(url.gas.parmUrl(id), httpRequestMethods.DELETE)
}

export function gasInput (parm) {
  return authAPIRequest(url.gas.input, httpRequestMethods.POST, parm)
}

// gasTank
export function gasTankGetGasTankList (parm) {
  return authAPIRequest(url.gasTank.parmUrl(parm.id), httpRequestMethods.GET, parm)
}

export function gasTankAddGasTank (parm) {
  return authAPIRequest(url.gasTank.parmUrl2(parm.gasid), httpRequestMethods.POST, parm)
}

export function gasTankGetChooseList (needGroupId) {
  return authAPIRequest(url.gasTank.gasChooseList, httpRequestMethods.GET, {noPage: 1, groupId: needGroupId ? store.getters.currentGroupId : null})
}

export function gasTankDataList (parm, getAll = false) {
  return authAPIRequest(url.gasTank.gasChooseList, httpRequestMethods.GET, getAll ? parm : parmAddData(parm, ['carTeams', 'groupIds', 'companyIds']))
}

export function gasTankUpdateGasTank (parm) {
  return authAPIRequest(url.gasTank.parmUrl(parm.id), httpRequestMethods.PUT, parm)
}

export function gasTankUpdateGasTankStatus (parm) {
  return authAPIRequest(url.gasTank.updateGasTankStatus, httpRequestMethods.PUT, parm)
}

export function gasTankDeleteGasTank (id) {
  return authAPIRequest(url.gasTank.parmUrl(id), httpRequestMethods.DELETE)
}

export function gasTankMergeGasTank (parm) {
  return authAPIRequest(url.gasTank.merge, httpRequestMethods.POST, parm)
}

// gasTankError
export function gasTankErrorGetData (parm) {
  return authAPIRequest(url.gasTankError.basUrl, httpRequestMethods.GET, parmAddData(parm, ['carTeams', 'groupIds', 'companyIds']))
}

export function gasTankErrorGetOilWarningData (parm) {
  return authAPIRequest(url.gasTankError.getWarningOilTank, httpRequestMethods.GET, parmAddData(parm, ['carTeams', 'groupIds', 'companyIds']))
}

export function gasTankErrorUpdateTank (parm) {
  return authAPIRequest(url.gasTankError.updateTank, httpRequestMethods.PUT, parm)
}

export function gasTankErrorGetYwy (parm) {
  return authAPIRequest(url.gasTankError.getYwy, httpRequestMethods.GET, parm)
}

// planCompared
export function planComparedGetData (parm) {
  return authAPIRequest(url.planCompared.basUrl, httpRequestMethods.GET, parmAddData(parm, ['carTeams', 'groupIds', 'companyIds']))
}

// piChart
export function piChart (parm) {
  return authAPIRequest(url.piChart.basUrl, httpRequestMethods.POST, parm)
}

export function piChartGetData (parm) {
  return authAPIRequest(url.piChart.getData, httpRequestMethods.POST, parm)
}

export function piChartNew (parm) {
  return authAPIRequest(url.piChart.newUrl, httpRequestMethods.POST, parm)
}

export function piChartTotal (parm) {
  return authAPIRequest(url.piChart.getTotalData, httpRequestMethods.POST, parm)
}

export function piChartHis (parm) {
  return authAPIRequest(url.piChart.his, httpRequestMethods.POST, parm)
}

export function piChartApi (parm) {
  return authAPIRequest(url.piChart.basUrl, httpRequestMethods.POST, parm)
}

export function piChartAlgo (id, parm) {
  return authAPIRequest(url.piChart.algo(id), httpRequestMethods.GET, parm)
}

// depot
export function depotGetDepotList (parm) {
  return authAPIRequest(url.depot.basUrl, httpRequestMethods.GET, parm)
}

export function depotAddDepot (parm) {
  return authAPIRequest(url.depot.basUrl, httpRequestMethods.POST, parm)
}

export function depotUpdateOil (parm) {
  return authAPIRequest(url.depot.updateOil, httpRequestMethods.PUT, parm)
}

export function depotUpdateDepot (parm) {
  return authAPIRequest(url.depot.parmUrl(parm.id), httpRequestMethods.PUT, parm)
}

export function depotDeleteDepot (id) {
  return authAPIRequest(url.depot.parmUrl(id), httpRequestMethods.DELETE)
}

export function depotOutputTemplate () {
  return authAPIRequest(url.depot.outputTemplate, httpRequestMethods.GET, {}, true)
}

export function depotInputUpdate (data) {
  return authAPIRequest(url.depot.inputUrl, httpRequestMethods.POST, data)
}

export function depotRuleGet (parm) {
  return authAPIRequest(url.depotRule.basUrl, httpRequestMethods.GET, parm)
}

export function depotRuleAdd (parm) {
  return authAPIRequest(url.depotRule.basUrl, httpRequestMethods.POST, parm)
}

export function depotRuleUpdate (parm) {
  return authAPIRequest(url.depotRule.parmUrl(parm.id), httpRequestMethods.PUT, parm)
}

export function depotOilRuleGet (parm) {
  return authAPIRequest(url.depotOilRule.basUrl, httpRequestMethods.GET, parm)
}

export function depotOilRuleUpdate (parm) {
  return authAPIRequest(url.depotOilRule.parmUrl(parm.id), httpRequestMethods.PUT, parm)
}

export function depotOilRuleAdd (parm) {
  return authAPIRequest(url.depotOilRule.basUrl, httpRequestMethods.POST, parm)
}

export function depotOilRuleDel (parm) {
  return authAPIRequest(url.depotOilRule.parmUrl(parm.id), httpRequestMethods.DELETE, parm)
}

export function depotDailyOilGet (parm) {
  return authAPIRequest(url.depotDailyOil.basUrl, httpRequestMethods.GET, parm)
}

export function depotDailyOilUpdate (parm) {
  return authAPIRequest(url.depotDailyOil.update, httpRequestMethods.POST, parm)
}

export function depotDailyOilDel (parm) {
  return authAPIRequest(url.depotDailyOil.del(parm.id), httpRequestMethods.DELETE, parm)
}

// driver
export function driverGetDriverList (parm) {
  return authAPIRequest(url.driver.basUrl, httpRequestMethods.GET, parm)
}

export function driverAddDriver (parm) {
  return authAPIRequest(url.driver.basUrl, httpRequestMethods.POST, parm)
}

export function driverUpdateDriver (parm) {
  return authAPIRequest(url.driver.parmUrl(parm.id), httpRequestMethods.PUT, parm)
}

export function driverDeleteDriver (id) {
  return authAPIRequest(url.driver.parmUrl(id), httpRequestMethods.DELETE)
}

// matchParm
export function matchParmGet (parm) {
  return authAPIRequest(url.matchParm.basUrl, httpRequestMethods.GET, parm)
}

export function matchParmAdd (parm) {
  return authAPIRequest(url.matchParm.basUrl, httpRequestMethods.POST, parm)
}

export function matchParmUpdte (parm) {
  return authAPIRequest(url.matchParm.parmUrl(parm.id), httpRequestMethods.PUT, parm)
}

export function matchParmDel (id) {
  return authAPIRequest(url.matchParm.parmUrl(id), httpRequestMethods.DELETE)
}

// monthPlan
export function monthPlanGet () {
  return authAPIRequest(url.monthPlan.basUrl, httpRequestMethods.GET)
}

export function monthPlanAdd (parm) {
  return authAPIRequest(url.monthPlan.basUrl, httpRequestMethods.POST, parm)
}

// yearData
export function yearDataGet () {
  return authAPIRequest(url.yearData.basUrl, httpRequestMethods.GET)
}

export function yearDataAdd (parm) {
  return authAPIRequest(url.yearData.basUrl, httpRequestMethods.POST, parm)
}

// car
export function carGetCarList (parm) {
  return authAPIRequest(url.car.basUrl, httpRequestMethods.GET, parmAddData(parm, ['carTeams', 'groupIds']))
}

export function carGetCarReferList (parm) {
  return authAPIRequest(url.car.carRefer, httpRequestMethods.GET, parm)
}

export function carGetCarListAll (parm) {
  return authAPIRequest(url.car.basUrl, httpRequestMethods.GET, parm)
}

export function carGetAllCarList (parm) {
  return authAPIRequest(url.car.basUrl, httpRequestMethods.GET, parm)
}

export function carAddCar (parm) {
  return authAPIRequest(url.car.basUrl, httpRequestMethods.POST, parm)
}

export function carUpdateCarBin (carId, parm) {
  return authAPIRequest(url.car.updateCarBin(carId), httpRequestMethods.POST, parm)
}

export function carUpdateCar (parm) {
  return authAPIRequest(url.car.parmUrl(parm.id), httpRequestMethods.PUT, parm)
}

export function carDeleteCar (id) {
  return authAPIRequest(url.car.parmUrl(id), httpRequestMethods.DELETE)
}

export function carOutputTemplate () {
  return authAPIRequest(url.car.outputTemplate, httpRequestMethods.GET, {}, true)
}

export function carInputUpdate (data) {
  return authAPIRequest(url.car.inputUrl, httpRequestMethods.POST, data)
}

// mapDistribution
export function mapDistributionGetCarRouter (parm) {
  return authAPIRequest(url.mapDistribution.getCarRouter, httpRequestMethods.GET, parm)
}

// carIOCard
export function carIOCardCarList (parm) {
  return authAPIRequest(url.carIOCard.basUrl, httpRequestMethods.GET, parmAddP(parm))
}

export function carIOCardAddData (parm) {
  return authAPIRequest(url.carIOCard.basUrl, httpRequestMethods.POST, parmAddP(parm))
}

export function carIOCardUpdateData (parm) {
  return authAPIRequest(url.carIOCard.parmUrl(parm.id), httpRequestMethods.PUT, parm)
}

export function carIOCardDeleteData (id) {
  return authAPIRequest(url.carIOCard.parmUrl(id), httpRequestMethods.DELETE)
}

// driverIOCard
export function driverIOCardCarList (parm) {
  return authAPIRequest(url.driverIOCard.basUrl, httpRequestMethods.GET, parmAddP(parm))
}

export function driverIOCardAddData (parm) {
  return authAPIRequest(url.driverIOCard.basUrl, httpRequestMethods.POST, parmAddP(parm))
}

export function driverIOCardUpdateData (parm) {
  return authAPIRequest(url.driverIOCard.parmUrl(parm.id), httpRequestMethods.PUT, parm)
}

export function driverIOCardDeleteData (id) {
  return authAPIRequest(url.driverIOCard.parmUrl(id), httpRequestMethods.DELETE)
}

// invicing
export function invoicingGetData (parm) {
  return authAPIRequest(url.invicing.basUrl, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'companyIds']))
}

export function invoicingAddData (parm) {
  return authAPIRequest(url.invicing.basUrl, httpRequestMethods.POST, parm)
}

export function invoicingDelData (parm) {
  return authAPIRequest(url.invicing.parmUrl(parm.id), httpRequestMethods.DELETE)
}

export function invoicingUpdateData (parm) {
  return authAPIRequest(url.invicing.parmUrl(parm.id), httpRequestMethods.PUT, parm)
}

export function invoicingInputData (parm) {
  return authAPIRequest(url.invicing.inputUrl, httpRequestMethods.POST, parm)
}

export function invoicingCountError (parm) {
  return authAPIRequest(url.invicing.countError, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'companyIds', 'carTeams']))
}

export function invoicingGasDailyError (parm) {
  return authAPIRequest(url.invicing.gasDailyError, httpRequestMethods.GET, parm)
}

export function invoicingGetNotReportData (parm) {
  return authAPIRequest(url.invicing.getNotReportData, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'companyIds']))
}

// warning 异常警告数据
export function getWarningData (parm) {
  return authAPIRequest(url.warning.basUrl, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'companyIds']))
}

export function getWarningTanks (parm) {
  return authAPIRequest(url.warning.getData, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'companyIds', 'carTeams']))
}

export function getWarningHisSaleWarning (parm) {
  return authAPIRequest(url.warning.getHisSaleWarning, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'companyIds', 'carTeams']))
}

export function getWarningTodaySaleWarning (parm) {
  return authAPIRequest(url.warning.getTodaySaleWarning, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'companyIds', 'carTeams']))
}

export function getWarningYc (parm) {
  return authAPIRequest(url.warning.getYcData, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'companyIds', 'carTeams']))
}

export function warningGetHisData (parm) {
  return authAPIRequest(url.warning.getHisData, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'companyIds', 'carTeams']))
}

export function warningUpdateTankStatus (parm) {
  return authAPIRequest(url.warning.updateGasTankStatus(parm.id, parm.status), httpRequestMethods.PUT)
}

export function warningAddDeal (parm) {
  return authAPIRequest(url.warning.addDeal, httpRequestMethods.POST, parm)
}

export function warningGetDeal (id) {
  return authAPIRequest(url.warning.getDeal(id), httpRequestMethods.GET)
}

export function warningGetDealDataNew (parm) {
  return authAPIRequest(url.warning.dealNew, httpRequestMethods.GET, parm)
}

export function warningAddDealNew (parm) {
  return authAPIRequest(url.warning.dealNew, httpRequestMethods.POST, parm)
}

export function warningUpdateDealNew (parm) {
  return authAPIRequest(url.warning.dealNewParmUrl(parm.id), httpRequestMethods.PUT, parm)
}

// invicingCheck
// export function invoicingCheckGetData (parm) {
//   return authAPIRequest(url.invicingCheck.basUrl, httpRequestMethods.GET, parmAddData(parm, ['groupIds', 'companyIds']))
// }
export function invoicingCheckGetYwyData (parm) {
  return authAPIRequest(url.invicingCheck.getYwyData, httpRequestMethods.GET, parm)
}

export function invoicingCheckUpdateDailyAndOrder (parm) {
  return authAPIRequest(url.invicingCheck.update, httpRequestMethods.PUT, parm)
}

export function invoicingCheckownFile (parm) {
  return authAPIRequest(url.invicingCheck.downFile, httpRequestMethods.GET, parmAddP(parm), true)
}

// gas_order
export function gasOrderGetData (parm) {
  return authAPIRequest(url.gasOrder.basUrl, httpRequestMethods.GET, parm)
}

export function gasOrderUpdateData (parm) {
  return authAPIRequest(url.gasOrder.parmUrl(parm.id), httpRequestMethods.PUT, parm)
}

export function gasOrderUpdateIsSend (parm) {
  return authAPIRequest(url.gasOrder.updateIsSend(parm.groupId, parm.dateStr, parm.rate), httpRequestMethods.PUT)
}

export function gasOrderPrediction (parm) {
  return authAPIRequest(url.gasOrder.prediction, httpRequestMethods.POST, parmAddP(parm))
}

export function gasOrderGetPredictionStatus () {
  return authAPIRequest(url.gasOrder.predictionStatus, httpRequestMethods.GET, parmAddP({}))
}

export function gasOrderClearData (parm) {
  return authAPIRequest(url.gasOrder.clearData(parm.sendTime, parm.groupId), httpRequestMethods.DELETE)
}

export function gasOrderOutput (parm) {
  return authAPIRequest(url.gasOrder.outPut, httpRequestMethods.GET, parmAddP(parm), true)
}

export function gasOrderConfirm (parm) {
  return authAPIRequest(url.gasOrder.confirm, httpRequestMethods.PUT, parm)
}

// car_sign
export function carSignGetData (parm) {
  return authAPIRequest(url.carSign.basUrl, httpRequestMethods.GET, parmAddData(parm, ['carTeams', 'groupIds']))
}

export function carSignIn (parm) {
  return authAPIRequest(url.carSign.signUrl, httpRequestMethods.POST, parm)
}

export function carSignUpdate (id, parm) {
  return authAPIRequest(url.carSign.parmUrl(id), httpRequestMethods.PUT, parm)
}

// carMonth
export function carMonthGetData (parm) {
  return authAPIRequest(url.carMonth.basUrl, httpRequestMethods.GET, parmAddData(parm, ['carTeams']))
}

export function carMonthUpdate (parm) {
  return authAPIRequest(url.carMonth.udpate, httpRequestMethods.POST, parm)
}

// adjust_order
export function adjustOrderGetData (parm) {
  return authAPIRequest(url.adjustOrder.getCar, httpRequestMethods.GET, parmAddP(parm))
}

export function adjustOrderValidateCar (parm) {
  return authAPIRequest(url.adjustOrder.validateCar(store.getters.currentGroupId, parm.carId, parm.sendTime), httpRequestMethods.GET)
}

// 获取可用车辆
export function adjustOrderGetCar (parm) {
  return authAPIRequest(url.adjustOrder.getCar, httpRequestMethods.GET, parmAddP(parm))
}

export function adjustOrderUpdateMatchStatus (status, datas) {
  return authAPIRequest(url.adjustOrder.updateMatchStatus(status), httpRequestMethods.PUT, datas)
}

// carMonitor 车辆监控
export function carMonitorGetData (parm) {
  return authAPIRequest(url.carMonitor.basUrl, httpRequestMethods.GET, parm)
}

export function carMonitorGetCarWay (parm) {
  return authAPIRequest(url.carMonitor.getCarWay, httpRequestMethods.GET, parm)
}

// gasSaleWarning 加油站销量预警
export function gasSaleWarningGetData (parm) {
  return authAPIRequest(url.gasSaleWarning.basUrl, httpRequestMethods.GET, parmAddData(parm, ['carTeams', 'groupIds', 'companyIds']))
}

export function gasSaleWarningGetDaySale (parm) {
  return authAPIRequest(url.gasSaleWarning.daySale, httpRequestMethods.GET, parm)
}

// distribution 导入配送计划

export function distributionGetData (parm) {
  return authAPIRequest(url.distribution.basUrl, httpRequestMethods.GET, parmAddData(parm, ['carTeams', 'groupIds']))
}

export function distributionAddData (parm) {
  return authAPIRequest(url.distribution.basUrl, httpRequestMethods.POST, parm)
}

export function distributionUpdateData (parm) {
  return authAPIRequest(url.distribution.parmUrl(parm.id), httpRequestMethods.PUT, parm)
}

export function distributionDelData (parm) {
  return authAPIRequest(url.distribution.parmUrl(parm.id), httpRequestMethods.DELETE)
}

export function distributionGetDataByCar (parm) {
  return authAPIRequest(url.distribution.basUrl, httpRequestMethods.GET, parm)
}

export function distributionGetDataByGas (parm) {
  return authAPIRequest(url.distribution.basUrl, httpRequestMethods.GET, parm)
}

// 根据配送单查询
export function distributionGetDataByPsdNo (parm) {
  return authAPIRequest(url.distribution.getByPsdNo, httpRequestMethods.GET, parm)
}

export function distributionGetDataProgress (parm) {
  return authAPIRequest(url.distribution.basUrl, httpRequestMethods.GET, parmAddData(parm, ['carTeams', 'groupIds', 'companyIds']))
}

export function distributionUpdateInTime (parm) {
  return authAPIRequest(url.distribution.updateInTime, httpRequestMethods.PUT, parm)
}

export function distributionGasTransfer (parm) {
  return authAPIRequest(url.distribution.gasTransfer, httpRequestMethods.POST, parm)
}

export function distributionInputData (parm) {
  return authAPIRequest(url.distribution.input, httpRequestMethods.POST, parm)
}

export function distributionUpdate (parm) {
  return authAPIRequest(url.distribution.update(parm.id), httpRequestMethods.PUT, parm)
}

export function distributionSysWriteoff (date) {
  return authAPIRequest(url.distribution.sysWriteoff(date), httpRequestMethods.PUT)
}

export function distributionWriteoffUpdate (parm) {
  return authAPIRequest(url.distribution.writeoffUpdate, httpRequestMethods.PUT, parm)
}

export function distributionWayOutput (parm) {
  return authAPIRequest(url.distribution.output, httpRequestMethods.GET, parmAddP(parm), true)
}

// planOrder
export function planOrderDown (parm) {
  return authAPIRequest(url.planOrder.down(parm.sendTime, parm.groupId), httpRequestMethods.POST)
}

export function planOrderOutput (parm) {
  return authAPIRequest(url.planOrder.output, httpRequestMethods.GET, parmAddP(parm), true)
}

export function planOrderGetData (parm) {
  return authAPIRequest(url.planOrder.basUrl, httpRequestMethods.GET, parmAddP(parm))
}

export function planOrderAddData (parm) {
  return authAPIRequest(url.planOrder.basUrl, httpRequestMethods.POST, parm)
}

export function planOrderUpdateData (parm) {
  return authAPIRequest(url.planOrder.parmUrl(parm.id), httpRequestMethods.PUT, parm)
}

export function planOrderDelData (id) {
  return authAPIRequest(url.planOrder.parmUrl(id), httpRequestMethods.DELETE)
}

// warningInvoicing
export function warningInvoicingGetData (parm) {
  return authAPIRequest(url.warningInvoicing.basUrl, httpRequestMethods.GET, parm)
}

// routerOrderRecord
export function routerOrderRecordAddData (parm) {
  return authAPIRequest(url.routerOrderRecord.basUrl, httpRequestMethods.POST, parm)
}

export function routerOrderRecordGetData (parm) {
  return authAPIRequest(url.routerOrderRecord.basUrl, httpRequestMethods.GET, parmAddData(parm, ['carTeams', 'groupIds', 'carTeams']))
}

export function routerOrderRecordGetRecord () {
  // return authAPIRequest(url.routerOrderRecord.getRecord, httpRequestMethods.GET, parmAddData({}, ['carTeams', 'groupIds', 'carTeams']))
  return authAPIRequest(url.routerOrderRecord.getRecord, httpRequestMethods.GET)
}

// routerOrder
export function routerOrderGetData (parm) {
  return authAPIRequest(url.routerOrder.basUrl, httpRequestMethods.GET, parmAddData(parm, ['carTeams', 'groupIds', 'carTeams']))
}

export function routerOrderUpdate (parm) {
  return authAPIRequest(url.routerOrder.updateData(parm.id), httpRequestMethods.PUT, parm)
}

export function routerOrderUpdateOne (parm) {
  return authAPIRequest(url.routerOrder.updateOne(parm.id), httpRequestMethods.PUT, parm)
}

export function routerOrderGetDataByGasOrderId (gasOrderId) {
  return authAPIRequest(url.routerOrder.getDataByGasOrderId(gasOrderId), httpRequestMethods.GET)
}

export function routerOrderGetDataByInfo (parm) {
  return authAPIRequest(url.routerOrder.getDataByInfo, httpRequestMethods.GET, parm)
}

export function routerOrderAddData (parm) {
  return authAPIRequest(url.routerOrder.basUrl, httpRequestMethods.POST, parm)
}

export function routerOrderAddOneData (parm) {
  return authAPIRequest(url.routerOrder.addOne, httpRequestMethods.POST, parm)
}

export function routerOrderUpdateData (id, sort) {
  return authAPIRequest(url.routerOrder.updateSort(id, sort), httpRequestMethods.PUT)
}

export function routerOrderDeleteData (id) {
  return authAPIRequest(url.routerOrder.parmUrl(id), httpRequestMethods.DELETE)
}

export function routerOrderCount (parm) {
  return authAPIRequest(url.routerOrder.count, httpRequestMethods.GET, parmAddP(parm))
}

export function routerOrderMatchOrder (parm) {
  return authAPIRequest(url.routerOrder.matchOrder, httpRequestMethods.POST, parmAddP(parm))
}

export function routerOrderGetMatchStatus (parm) {
  return authAPIRequest(url.routerOrder.matchStatus, httpRequestMethods.GET, parmAddP(parm))
}

export function routerOrderOutPut (parm) {
  return authAPIRequest(url.routerOrder.outPut, httpRequestMethods.GET, parmAddData(parm, ['carTeams', 'groupIds', 'companyIds']), true)
}

export function routerOrderOutPut2 (parm) {
  return authAPIRequest(url.routerOrder.outPut2, httpRequestMethods.GET, parmAddData(parm, ['carTeams', 'groupIds', 'companyIds']), true)
}

export function routerOrderOutPutQS (parm) {
  return authAPIRequest(url.routerOrder.outPutQS, httpRequestMethods.GET, parmAddData(parm, ['carTeams', 'groupIds']), true)
}

export function routerOrderOutPutMx (parm) {
  return authAPIRequest(url.routerOrder.outPutMx, httpRequestMethods.GET, parmAddData(parm, ['carTeams', 'groupIds']))
}

export function routerOrderOutPutCar (parm) {
  return authAPIRequest(url.routerOrder.outPutCar, httpRequestMethods.GET, parmAddData(parm, ['carTeams', 'groupIds', 'companyIds']), true)
}

export function routerOrderClearData (parm) {
  return authAPIRequest(url.routerOrder.clearData(parm.sendTime, parm.groupId), httpRequestMethods.DELETE)
}

export function routerOrderInputData (parm) {
  return authAPIRequest(url.routerOrder.inputUrl, httpRequestMethods.POST, parmAddP(parm))
}

export function routerOrderCheck (parm) {
  return authAPIRequest(url.routerOrder.check, httpRequestMethods.POST, parm)
}

export function routerOrderRevoke (parm) {
  return authAPIRequest(url.routerOrder.revoke, httpRequestMethods.POST, parm)
}

// gasPiOrder
export function gasPiOrderGetData (gasOrderId) {
  return authAPIRequest(url.gasPiOrder.getData(gasOrderId), httpRequestMethods.GET)
}

export function gasPiOrderUpdateData (gasOrderId, piOrderList) {
  return authAPIRequest(url.gasPiOrder.updateData(gasOrderId), httpRequestMethods.POST, piOrderList)
}

export function gasPiOrderOutPut (parm) {
  return authAPIRequest(url.gasPiOrder.outPut, httpRequestMethods.GET, parmAddP(parm), true)
}

export function gasPiOrderOutPut2 (parm) {
  return authAPIRequest(url.gasPiOrder.outPut2, httpRequestMethods.GET, parmAddP(parm), true)
}

export function gasPiOrderCount (parm) {
  return authAPIRequest(url.gasPiOrder.count, httpRequestMethods.GET, parmAddP(parm))
}

// gas demand 油站要货
export function gasDemandGetData (parm) {
  return authAPIRequest(url.gasDemand.basUrl, httpRequestMethods.GET, parmAddP(parm))
}

export function gasDemandInputData (file) {
  let parm = new window.FormData()
  parm.append('file', file, file.name)
  return fileAPIRequest(url.gasDemand.inputUrl, httpRequestMethods.POST, parm)
}

// globParm
export function globParmGetGroupAreas () {
  return authAPIRequest(url.globParm.getGroupAreas, httpRequestMethods.GET, parmAddP({noPage: 1}))
}

export function globParmGetGroupAgents () {
  return authAPIRequest(url.globParm.getGroupAgents, httpRequestMethods.GET, parmAddP({noPage: 1}))
}

// piGasTankStatus
export function piGasTankStatusGetStatus (parm) {
  return authAPIRequest(url.piGasTankStatus.basUrl, httpRequestMethods.GET, parm)
}

export function piGasTankStatusGetDistribution (parm) {
  return authAPIRequest(url.piGasTankStatus.getDistribution, httpRequestMethods.GET, parm)
}

// oilType
export function oilTypeGetData () {
  return authAPIRequest(url.oilType.basUrl, httpRequestMethods.GET)
}

export function oilTypeUpdateData (id, parm) {
  return authAPIRequest(url.oilType.parmUrl(id), httpRequestMethods.PUT, parm)
}

// gastankEmergency
export function gastankEmergencyGet (parm) {
  return authAPIRequest(url.gastankEmergency.basUrl, httpRequestMethods.GET, parm)
}

export function gastankEmergencyUpdate (id, parm) {
  return authAPIRequest(url.gastankEmergency.parmUrl(id), httpRequestMethods.PUT, parm)
}

// planReport
export function planReportGet (parm) {
  return authAPIRequest(url.planReport.basUrl, httpRequestMethods.GET, parm)
}

// carRule
export function carRuleGetData (parm) {
  return authAPIRequest(url.carRule.basUrl, httpRequestMethods.GET, parmAddData(parm, ['carTeams', 'groupIds']))
}

export function carRuleAddData (parm) {
  return authAPIRequest(url.carRule.basUrl, httpRequestMethods.POST, parm)
}

export function carRuleUpdateData (id, parm) {
  return authAPIRequest(url.carRule.parmUrl(id), httpRequestMethods.PUT, parm)
}

export function carRuleInput (file) {
  let parm = new window.FormData()
  parm.append('file', file, file.name)
  parm.append('keys', '车牌号,licenseNo,可配送油站加管code,gasJgCode,场地限制,gasLimit,通行证,gatePass,通行证区域,gatePassType,运距限制,maxDistance,投产日期,startWorkTime,任务指标,taskTarget,工作年限,workYear')
  return fileAPIRequest(url.carRule.input, httpRequestMethods.POST, parm, true)
}

// gasRule
export function gasRuleGetData (parm) {
  return authAPIRequest(url.gasRule.basUrl, httpRequestMethods.GET, parmAddData(parm, ['carTeams', 'groupIds', 'companyIds']))
}

export function gasRuleAddData (parm) {
  return authAPIRequest(url.gasRule.basUrl, httpRequestMethods.POST, parm)
}

export function gasRuleUpdateData (id, parm) {
  return authAPIRequest(url.gasRule.parmUrl(id), httpRequestMethods.PUT, parm)
}

export function gasRuleInput (file) {
  let parm = new window.FormData()
  parm.append('file', file, file.name)
  parm.append('keys', '指定配送车辆,carNo,加管编码,jgCode,不能配送车辆,exCarNo,需要通行证,requireGatePass,加油站限制,gasLimit,通行证类型,gatePassType,卸油时间,unloadHour,道路状况,roadStatus,优先配送车型,carType,通行时间,inHours,进站时长,gatePassTime')
  return fileAPIRequest(url.gasRule.input, httpRequestMethods.POST, parm, true)
}

// uploadFile
export function uploadXFMX (file) {
  let parm = new window.FormData()
  parm.append('file', file, file.name)
  // parm.append('file', file, 'fileName')
  return fileAPIRequest('/cnpc/otherbus/excel/custom/rebate', httpRequestMethods.POST, parm)
}

export function getCarLine (parm) {
  return authAPIRequest(url.carLine.basUrl, httpRequestMethods.POST, parm)
}

export function updateCarLinePlan (parm) {
  return authAPIRequest(url.carLine.plan, httpRequestMethods.POST, parm)
}



// WEBPACK FOOTER //
// ./src/api/api.js